import { ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { Table } from 'components/Table';
import { H4 } from 'components/Text/H4';
import { colors, cssBreakpoints, gutterWidth, maxWidth } from 'theme';
import { getStaticImageSrc } from 'utils/getImageSrc';

export const aCycle = (data: ReactNode[][]) =>
  keyframes`
  ${data.map(
    (_, i) => css`
      ${(100 / (data.length - 4)) * i}% {
        transform: translateY(${-46 * i}px);
      }
    `,
  )}
`;

export const RecentSubmissionsContainer = styled.div`
  justify-content: center;
  background-image: url('${() => getStaticImageSrc('salary-bg.svg')}');
  background-size: cover;
  color: ${colors.white};
  display: flex;
  width: 100%;
`;

export const RecentSubmissionsWrapper = styled.div`
  align-items: center;
  display: flex;
  max-width: ${maxWidth[4]}px;
  padding: ${gutterWidth * 2}px;
`;

export const RecentSubmissionsHeading = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    align-items: initial;
    padding-right: 120px;
    text-align: left;
  }
`;

export const TableHeading = styled(H4)`
  margin-bottom: 0;
  padding: 16px 30px 0;
  position: relative;
  z-index: 2;
`;

export const TableContainer = styled.div`
  background: ${colors.white};
  color: ${colors.mediumContentGrey};
  display: none;
  border-radius: 10px;
  width: 100%;
  overflow: hidden;

  > div {
    height: 228px;
    overflow: hidden;
    padding: 0;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    display: table;
  }
`;

type TableProps = {
  data: ReactNode[];
  $animationName: ReturnType<typeof keyframes>;
};

export const StyledTable = styled(Table)<TableProps>`
  background: ${colors.backgroundGrey};
  padding: 0 30px;

  thead {
    background: ${colors.white};
    position: sticky;
    z-index: 2;
  }

  tbody {
    animation-name: ${(props) => props.$animationName};
    animation-duration: ${(props) => 3 * (props.data.length - 4)}s;
    animation-iteration-count: infinite;
    position: relative;
    z-index: 1;
  }
`;

export const SurveyButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;
